<template>
  <div class="pageContainer">
    <div class="topDiv backgroundCoverImageCenter">
      <h1>
       Destinations
      </h1>
    </div>
    <div class="bottomDiv">
    </div>
  </div>
</template>

<script>
export default {
  name: 'destinations' /*,
  data () {
    return {}
  } */
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~scssDir/_breakpoints.scss";
@import "~scssDir/_variables.scss";
@import "~scssDir/_myAnimations.scss";
.topDiv {
  height: 60px;
  background-color: $color5;
  @include media-md{
    height:30vh;
  }
  h1 {
    line-height: 20px;
    color: $color2;
    @include media-md{
      line-height: unset;
    }
  }
}
.bottomDiv {
  height: 70vh;
  background-color: $color4;
}
</style>



// WEBPACK FOOTER //
// src/components/destinations.vue